import {ErrorMap} from '@/utils/errors/errorManager';

import {API_URL_BANKING} from '../constants';

export const apiBasePaymentLink = {
  baseUrl: API_URL_BANKING,
  endpoints: {
    getPaymentLink: '/public/account/v1/request-money',
    getFees: '/public/account/v1/fund/checkout/fees',
    getCheckoutLink: '/public/account/v1/fund/checkout/link',
    getCheckoutResult: '/public/account/v1/fund/checkout',
  },
};

export const PAYMENT_LINK_ERROR_MAP: ErrorMap = {
  ['BankingAccountIsNotActive']: {
    TITLE: `The recipient's account is inactive`,
    DETAILS: `We couldn't complete the payment because the recipient's checking account is not currently active. Please contact the recipient or try again later.`,
  },
};

export const PaymentLinkFlows = {
  QR: 'QR',
  LINK: 'LINK',
};
